// create/post
export const CREATE_TENANT_BANK_ACCOUNT_MAP_REQUEST = "CREATE_TENANT_BANK_ACCOUNT_MAP_REQUEST";
export const CREATE_TENANT_BANK_ACCOUNT_MAP_SUCCESS = "CREATE_TENANT_BANK_ACCOUNT_MAP_SUCCESS";
export const CREATE_TENANT_BANK_ACCOUNT_MAP_FAIL = "CREATE_TENANT_BANK_ACCOUNT_MAP_FAIL";

// get
export const TENANT_BANK_ACCOUNT_MAP_REQUEST = "TENANT_BANK_ACCOUNT_MAP_REQUEST";
export const TENANT_BANK_ACCOUNT_MAP_SUCCESS = "TENANT_BANK_ACCOUNT_MAP_SUCCESS";
export const TENANT_BANK_ACCOUNT_MAP_FAIL = "TENANT_BANK_ACCOUNT_MAP_FAIL";

// update/put
export const UPDATE_TENANT_BANK_ACCOUNT_MAP_REQUEST = "UPDATE_TENANT_BANK_ACCOUNT_MAP_REQUEST";
export const UPDATE_TENANT_BANK_ACCOUNT_MAP_SUCCESS = "UPDATE_TENANT_BANK_ACCOUNT_MAP_SUCCESS";
export const UPDATE_TENANT_BANK_ACCOUNT_MAP_FAIL = "UPDATE_TENANT_BANK_ACCOUNT_MAP_FAIL";

// delete/put
export const DELETE_TENANT_BANK_ACCOUNT_MAP_REQUEST = "DELETE_TENANT_BANK_ACCOUNT_MAP_REQUEST";
export const DELETE_TENANT_BANK_ACCOUNT_MAP_SUCCESS = "DELETE_TENANT_BANK_ACCOUNT_MAP_SUCCESS";
export const DELETE_TENANT_BANK_ACCOUNT_MAP_FAIL = "DELETE_TENANT_BANK_ACCOUNT_MAP_FAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";